import { Component, Input, OnInit } from '@angular/core';
import { GrundstueckListEntryMeta } from '../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { TranslateNamePipe } from '../../../shared/pipes/simple/translate-name.pipe';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import {
  GrundstueckListEntryVm,
  GrundstueckSelection,
  GrundstueckTableComponent
} from '../../../shared/widgets/grundstueck-table/grundstueck-table.component';
import { KompaktGrundstueckPipe } from '../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { KompaktGrundstueckbeschreibungPipe } from '../../../shared/kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import { DokulinkItemBuilderFactory } from 'app/shared/components/dokulink/dokulinkItemBuilderFactory';
import { GrundstuecknummerPipe } from '../../../shared/pipes/simple/grundstuecknummer.pipe';
import { GbPrintService } from '../../../core/services/app-print.service';
import { AuszugPrintService } from '../../../shared/components/auszug/auszug-print-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrundstueckAuszugSettingsComponent } from '../../../shared/components/auszug/settings/grundstueck-auszug-settings.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';

@Component({
  selector: 'cap-recht-perimeter',
  templateUrl: './recht-perimeter.component.html',
  styleUrls: ['./recht-perimeter.component.scss'],
  imports: [TitleFunctionbarComponent, GrundstueckTableComponent, TranslatePipe]
})
export class RechtPerimeterComponent implements OnInit {
  @Input()
  perimeter: Array<GrundstueckListEntryMeta>;

  listLoader: ListLoaderPreloaded<GrundstueckListEntryVm>;
  grundstueckIds = [];

  constructor(
    private translate: TranslateService,
    protected translateName: TranslateNamePipe,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibung: KompaktGrundstueckbeschreibungPipe,
    private comperatorService: ComparatorService,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    public gbPrintService: GbPrintService,
    private auszugService: AuszugPrintService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.perimeter.sort((a, b) => this.comperatorService.grundstueckComparator(a, b));
    const grundstueckListEntryVms = this.perimeter.map(
      (g) =>
        new GrundstueckListEntryVm(g, {
          translate: this.translate,
          grundstuecknummerPipe: this.grundstuecknummerPipe,
          kompaktGrundstueckBeschreibung: this.kompaktGrundstueckBeschreibung,
          kompaktGrundstueckPipe: this.kompaktGrundstueckPipe,
          dokuLinkBuilderFactory: this.dokuLinkBuilderFactory
        })
    );
    this.listLoader = new ListLoaderPreloaded<GrundstueckListEntryVm>(15, 1, grundstueckListEntryVms);
  }

  updateCheckedGrundstueckIdList($event: GrundstueckSelection) {
    this.grundstueckIds = $event.grundstueckIds;
  }

  getZip() {
    this.selectGrundstueckSettings(this.grundstueckIds);
  }

  selectGrundstueckSettings(list) {
    const modalRef = this.modalService.open(GrundstueckAuszugSettingsComponent);
    modalRef.componentInstance.hasToZip = true;
    modalRef.componentInstance.ids = list;
    modalRef.componentInstance.indexNumber = 0;
  }
}
